export const LIST_ITEMS = [
  'Clique no botão abaixo para acessar suas faturas em aberto.',
  <>
    Selecione na fatura a opção <strong>&quot;Copiar Código&quot;</strong> para copiar o código de
    barras
  </>,
  'Acesse o app do seu banco, escolha pagar boleto, cole o código e finalize o pagamento',
]
